import { render, staticRenderFns } from "./contentInfoUser.vue?vue&type=template&id=d67dd57e"
import script from "./contentInfoUser.vue?vue&type=script&lang=js"
export * from "./contentInfoUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports